import 'styled-components'

const theme = {
  colors: {
    confirm: '#25a37b',
    confirmHover: '#2dca98',
    cancel: '#a6312d',
    cancelHover: ' #6b1e1e',
    lightBlue: '#487ab5',
    blue: '#002d62',
    gray: '#E3E3E3',
    white: '#FFFFFF',
    lightBlue2: '#A8CBFF',
    red: '#CC0000DE ',
    red2: '#F50000',
    blue2: '#1D00CCDE',
    gray2: '#F5F5F5',
    orange: '#D76700',
    orange2: '#ff8f1f',
    lightOrange: '#FEE1C7',
    darkBlueHover: '#3079d1',
    gray3: '#808080',
    gray4: '#c7c9c7',
    gray5: '#999494',
    gray6: '#78909C',
    lightGray: '#d9d9d9',
    darkGray: '#424242',
    green: '#A6FFA5',
    green2: '#2DA77B',
    green3: '#8EB44D',
    green4: '#83cb86',
    pink: '#FFBFBF',
    disabled: '#bbbbbb',
    yellow: '#FFE03F',
    darkBlue: '#002d62',
    redHover: '#F50000',
    lightRed: '#a84848',
    black: '#000000',
    lightBlue3: '#1976D2',
    lightBlue4: '#839bcb',
    lightBlue5: '#1677ff',
    lightBlue6: '#a2c9ff',
    darkBlueHover2: '#1565C0',
    orange3: '#FFA500',
    darkOrangeHover: '#BB6815',
  },
}

export type Theme = typeof theme

declare module 'styled-components' {
  export interface DefaultTheme extends Theme { }
}

export default theme
